import axiosInstance, { getAPIURL } from "./axiosInstance";

export type ExplorerOnboardingPayload = {
  v?: number;
  segment?: string;
  flowType?: string;
  discoveryAnswers?: Record<string, string>;
  badge?: string;
  eventId?: number | null;
  completedUtc?: string | null;
  businessSector?: string;
};

export type ExplorerProfileSaveBody = {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  city?: string;
  jobTitle?: string;
  companyName?: string;
  sector?: string;
  entrySource: string;
  eventId?: number | null;
  gdprConsent: boolean;
  marketingConsent?: boolean;
  attendeeType?: string;
  objectives?: string;
  discoveryAnswers?: Record<string, string>;
};

export async function saveExplorerPublicProfile(body: ExplorerProfileSaveBody & {
  email: string;
}) {
  const res = await axiosInstance.post(getAPIURL("/ExplorerOnboarding/public-profile"), body);
  return res.data as { message: string; email: string };
}

/** Logged-in upsert: same fields as public-profile, email taken from JWT (no already_registered block). */
export async function saveExplorerProfile(body: ExplorerProfileSaveBody) {
  const res = await axiosInstance.post(getAPIURL("/ExplorerOnboarding/profile"), body);
  return res.data as { message: string; email: string };
}

export async function saveExplorerOnboarding(body: {
  segment?: string;
  flowType?: string;
  discoveryAnswers?: Record<string, string>;
  eventId?: number | null;
}) {
  const res = await axiosInstance.post(getAPIURL("/ExplorerOnboarding/save"), body);
  return res.data as { message: string; payload: ExplorerOnboardingPayload };
}

export async function completeExplorerOnboarding(body?: {
  badge?: string;
  eventId?: number | null;
}) {
  const res = await axiosInstance.post(getAPIURL("/ExplorerOnboarding/complete"), body ?? {});
  return res.data as { message: string; payload: ExplorerOnboardingPayload };
}

export async function getMyExplorerOnboarding() {
  const res = await axiosInstance.get(getAPIURL("/ExplorerOnboarding/me"));
  return res.data as {
    explorer: unknown;
    payload: ExplorerOnboardingPayload | null;
  };
}

export async function getExplorerEventByCode(eventCode: string) {
  const safeCode = encodeURIComponent(eventCode.trim());
  const res = await axiosInstance.get(getAPIURL(`/Event/by-code/${safeCode}`));
  return res.data as {
    id: number;
    eventCode: string | null;
    name: string;
    eventDate: string;
  };
}
